import { connect } from "react-redux";
/*
import saveAs from "file-saver";
*/

import { postJSONexpectJSON } from "../netzwerk/FetchWithToken";

import StoerspeicherInfoPanel from "./StoerspeicherInfoPanel";

import { receivedErrorLog } from "../model/Fehlerspeicher";

const morphReceivedErrorLog = (rcv) => {
	return rcv.map(e => {
		let result = {
			date: new Date(e.datum),
			componentIndex: e.source,
			bitIndex: e.bit_index - 1,	// hier den ache-db-inheränten offset ausgleichen, damit das fehlertexte holen funktioniert!
			compressorContexts: [
			],
			plantContext: {
				delivery_volume_m3min: e.plant_delivery_m3min,
				volume_flow_m3min: e.plant_volume_flow_m3min,
				line_pressure_bar: e.plant_line_pressure_bar,
				load_factor_percent: e.plant_load_factor_percent,
				status: e.plant_state
			}
		};
		for (let i = 1; i <= 10; ++i) {
			if (e["comp" + i + "_technology"] !== 0) {
				result.compressorContexts.push({
					cindex: i - 1,
					status: e["comp" + i + "_state"],
					technology: e["comp" + i + "_technology"]
				});
			}
		}

		return result;
	});
};
/*
const doDownload = () => {
	postJSONexpectJSON("/error_log/all", {}).then(response => {
		if (!response.ok) {
			return response.text().then(text => { throw(text); });
		}
		return response.json();
	}).then(body => {
		saveAs(new Blob([body], {type: "text/comma-separated-values"}), "errors.csv");
	}).catch(() => {
		//alert(error);
	});
};
*/

export default connect(null, (dispatch) => ({
	doUpdate: () => {
		/* Hier als JSON */
		postJSONexpectJSON("/error_log/all", {}).then(response => {
			if (!response.ok) {
				return response.text().then(text => { throw(text); });
			}
			return response.json();
		}).then(body => {
			dispatch(receivedErrorLog(morphReceivedErrorLog(body)));
		}).catch(error => {
			//alert(error);
		});
	}
	/*
	doDownload: doDownload,
	doReset: () => {
		postJSONexpectJSON("/error_log/reset", {});
	}
	*/
}))(StoerspeicherInfoPanel);
